export default "__VITE_ASSET__B1bD1Kqo__"